<template>
  <div class="modal_card reverse" style="width: 100vw">
    <div class="modal_form">
      <i @click="$emit('close')" class="icon-close"></i>
      <h1>Добавить курс данной группе</h1>
      <form @submit.prevent="$emit('attach')">
        <b-field label="Дата начала" class="input_datepicker label_left grey is-right">
          <b-datepicker
            animation=""
            v-model="modalInfo.date_start"
            size="is-small"
            placeholder="__.__.____"></b-datepicker>
        </b-field>

        <CoursesList 
          :checked-courses="checked" 
          :course-add="true" 
          :categories-list="categoriesList"
          :user-courses="userCourses" 
        />

        <button class="add_course_button modal_button left_button" type="submit">Добавить</button>
        <button type="button" @click="$emit('close')" class="close_button modal_button right_button">
          Отмена
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import CoursesList from '@/components/right_block/CoursesList'

export default {
  components: { CoursesList },
  props: {
    modalInfo: {
      default: () => {},
      type: Object,
    },
    categoriesList: {
      default: () => [],
      type: Array,
    },
    checked: {
      default: () => {},
      type: Object,
    },
    userCourses: {
      default: () => [],
      type: Array,
    },
  },
}
</script>
